import React, {useEffect, useState} from 'react';
import { Card, CardBody, CardTitle, Collapse } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import AmenityTypeFilters from "./_filters";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import { showToastCustom } from "../../../components/toast/customToast";
import { showLoader } from "../../../components/loader/loader";
import { ButtonTableDelete, ButtonTableEdit, ButtonTableFilter } from "../../../components/buttons/buttonsActions";
import { amenityTypeService } from "../../../jwt/_services/hotel/amenityTypeService";
import { ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, error, LIST, NO, NO_DATA_FOUND, YES } from "../../../components/i18n/i18n";

export default function AmenityTypeList(props) {

    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    // Filter props
    const [collapsed, setCollapsed] = useState(true);
    const [dataFilter, setDataFilter] = useState({
        code        : null,
        category    : null,
        udn      : null,
        status      : null
    });

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage, dataFilter);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage, dataFilter);
    };

    const refreshDataList = (page, currentIndex, sizePerPage, _dataFilters) => {
        setLoading(true);
        amenityTypeService.search(currentIndex, sizePerPage, _dataFilters)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        amenityTypeService.deleteItem(data.id).then(_ => {
            setLoading(false);
            refreshDataList(page, currentIndex, sizePerPage);
        }).catch(error => {
            console.log("Error al eliminar el contacto ",error);
            setLoading(false);
        })
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, "FORM");
    }

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
    }

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const handleStatusChange = async (id, data, status) => await amenityTypeService.updateItem(id, { ...data, status:status })

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
    }, {
        dataField: 'id',
        headerStyle: {width: '10%'},
        text: 'ID',
    }, {
        dataField: 'code',
        text: 'Codigo',
    }, {
        dataField: 'status',
        text: "Activo",
        headerStyle: {width: '80px'},
        headerAlign: 'center',
        align:'center',
        formatter: (cell, row) => <GenericSwitch
            id={ row?.id }
            initialState={ row?.status }
            onChange={ handleStatusChange }
        />
    }, {
        dataField: '-',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align:'center',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }];

    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                    {LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}  >
                    <AmenityTypeFilters refreshFiltered={refreshFiltered} />
                </Collapse>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({page, sizePerPage, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}